import { TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';

import { useWizardStateContext } from '@/app/[locale]/product/_contexts/WizardStateProvider';
import type { UseDiscountMessageProps } from '@/app/[locale]/product/_hooks/useDiscountMessage';
import useDiscountMessage from '@/app/[locale]/product/_hooks/useDiscountMessage';

const DiscountMessage = () => {
  const { isAccessory, isOuraRing4Wizard } = useWizardStateContext();
  const { displayMessage } = useDiscountMessage({
    isAccessory,
    isOuraRing4Wizard,
  } as UseDiscountMessageProps);

  return (
    <div
      data-cy="banner-message"
      className={cx(
        'absolute top-0 right-0 left-0 z-20 w-screen transform bg-white text-center transition duration-300 ease-in-out motion-reduce:transition-none',
        {
          '-translate-y-full opacity-0': !displayMessage,
          'translate-y-0 opacity-100': displayMessage,
        },
      )}
    >
      {displayMessage && (
        <div className="mx-auto max-w-7xl px-1 py-[1.0625rem]">
          <TypographyV3
            variant="body-small"
            weight="normal"
            align="center"
            height="none"
          >
            <span data-cy="discount-message-text">{displayMessage}</span>
          </TypographyV3>
        </div>
      )}
    </div>
  );
};

export default DiscountMessage;
